export default __webpack_public_path__ + "static/media/spacerace2.54c2d92a.png";